import { render, staticRenderFns } from "./graphs-1pmc.vue?vue&type=template&id=6351177d&scoped=true&"
import script from "./graphs-1pmc.vue?vue&type=script&lang=js&"
export * from "./graphs-1pmc.vue?vue&type=script&lang=js&"
import style0 from "./graphs-1pmc.vue?vue&type=style&index=0&id=6351177d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351177d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6351177d')) {
      api.createRecord('6351177d', component.options)
    } else {
      api.reload('6351177d', component.options)
    }
    module.hot.accept("./graphs-1pmc.vue?vue&type=template&id=6351177d&scoped=true&", function () {
      api.rerender('6351177d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/graphs-1pmc.vue"
export default component.exports